/**
 * Новый BF-дизайн включён по умолчанию; выключается `bf-redesign=0` в localStorage или `?bf=0`.
 */
export function isBfRedesignEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search || '');
    const fromUrl = params.get('bf');
    if (fromUrl === '1') return true;
    if (fromUrl === '0') return false;
    return localStorage.getItem('bf-redesign') !== '0';
  } catch {
    return true;
  }
}
